export const mediaGalleryText = {
  item: { key: 'media_gallery_item', fallback: { en: 'Media {index}', he: 'מדיה {index}' } },
  preview: { key: 'attachment_preview_name', fallback: { en: 'Preview {name}', he: 'תצוגה מקדימה של {name}' } },
  uploading: { key: 'attachment_uploading_name', fallback: { en: 'Uploading {name}', he: 'העלאת {name}' } },
  failed: { key: 'attachment_upload_failed', fallback: { en: 'Upload failed', he: 'ההעלאה נכשלה' } },
  retry: { key: 'media_gallery_retry', fallback: { en: 'Retry upload of {name}', he: 'ניסיון נוסף להעלאת {name}' } },
  reorder: { key: 'media_gallery_reorder', fallback: { en: 'Reorder {name}', he: 'שינוי הסדר של {name}' } },
  mainPhoto: { key: 'media_gallery_main_photo', fallback: { en: 'Main photo', he: 'תמונה ראשית' } },
  uploaded: { key: 'media_gallery_uploaded_item', fallback: { en: 'Uploaded {index}', he: 'קובץ שהועלה {index}' } },
  remove: { key: 'attachment_remove_name', fallback: { en: 'Remove {name}', he: 'הסרת {name}' } },
  file: { key: 'file', fallback: { en: 'File', he: 'קובץ' } },
}
